/**
 * AdminPanel.jsx — Painel principal de administração.
 * Só acessível a utilizadores com role admin.
 * Sub-vistas: Thresholds | Score de Saúde | Sincronização | Utilizadores
 */

import React, { useState } from "react";
import ThresholdSettings from "./ThresholdSettings";
import ScoreSettings from "./ScoreSettings";
import SyncSettings from "./SyncSettings";
import UserSettings from "./UserSettings";
import ProjectManagerSettings from "./ProjectManagerSettings";
import OperationalManagerSettings from "./OperationalManagerSettings";
import HeadSettings from "./HeadSettings";
import PlannerAssignment from "./PlannerAssignment";

const TABS = [
  { id: "planners",      label: "Atribuição de Planners", icon: "🗂️" },
  { id: "heads",         label: "Heads",                  icon: "⭐" },
  { id: "pms",           label: "Project Managers",       icon: "👤" },
  { id: "oms",           label: "Operational Managers",   icon: "👥" },
  { id: "thresholds",    label: "Thresholds de Alerta",   icon: "🔔" },
  { id: "score",         label: "Score de Saúde",         icon: "📈" },
  { id: "sync",          label: "Sincronização",          icon: "🔄" },
  { id: "utilizadores",  label: "Utilizadores",           icon: "🔐" },
];

export default function AdminPanel() {
  const [tabAtiva, setTabAtiva] = useState("planners");

  const renderTab = () => {
    switch (tabAtiva) {
      case "planners":     return <PlannerAssignment />;
      case "heads":        return <HeadSettings />;
      case "pms":          return <ProjectManagerSettings />;
      case "oms":          return <OperationalManagerSettings />;
      case "thresholds":   return <ThresholdSettings />;
      case "score":        return <ScoreSettings />;
      case "sync":         return <SyncSettings />;
      case "utilizadores": return <UserSettings />;
      default:             return <PlannerAssignment />;
    }
  };

  return (
    <div>
      <h1 style={styles.titulo}>Painel de Administração</h1>

      <div className="admin-tab-bar" style={styles.tabBar}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            style={{
              ...styles.tabBtn,
              ...(tabAtiva === tab.id ? styles.tabAtiva : {}),
            }}
            onClick={() => setTabAtiva(tab.id)}
          >
            <span>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div style={styles.tabConteudo}>
        {renderTab()}
      </div>
    </div>
  );
}

const styles = {
  titulo: { fontSize: 24, fontWeight: 700, marginBottom: 24 },
  tabBar: { display: "flex", gap: 4, borderBottom: "2px solid #e2e8f0", marginBottom: 24 },
  tabBtn: {
    display: "flex", alignItems: "center", gap: 8,
    padding: "10px 20px", background: "none", border: "none",
    borderBottom: "2px solid transparent", marginBottom: -2,
    fontSize: 14, cursor: "pointer", color: "#64748b", fontWeight: 500,
  },
  tabAtiva: { borderBottomColor: "#6366f1", color: "#6366f1", fontWeight: 700 },
  tabConteudo: {},
};
